/**
 * Typed search object for the `/scores/search` route (ISSUE-1380). The typed
 * text lives in `?q=`, so a search survives a refresh and Back returns to it.
 * Coerce, never type-guard: TanStack's default parser turns `?q=49` into a
 * number (see `searchParams.ts`).
 */
import { coerceOptionalString } from "./searchParams";

export type typeScoreSearchSearch = { q?: string | undefined };

export function validateScoreSearch(
  search: Record<string, unknown>,
): typeScoreSearchSearch {
  return { q: coerceOptionalString(search.q) };
}
